import data from './stop-words.json';

export const stopWords = new Set(data);